import { Grid, Card, CardHeader, CardContent, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { ConfirmationNumber, Build, ReportProblem, CheckCircle } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { StatCard } from '../../components/StatCard';
import { MiniBarChart } from '../../components/MiniBarChart';
import { StatusBadge } from '../../components/StatusBadge';
import { EmptyState } from '../../components/EmptyState';
import { serviceTicketsApi } from '../../api/serviceTickets.api';

const n = (x = 0) => Number(x).toLocaleString('en-IN');

export function ServiceDashboardPage() {
  const dash = useQuery({ queryKey: ['service-tickets', 'dashboard'], queryFn: () => serviceTicketsApi.dashboard() });
  const d = dash.data;
  const statusData = d ? Object.entries(d.byStatus).map(([label, value]) => ({ label: label.replace(/_/g, ' '), value, color: '#1e40af' })) : [];
  const typeData = d ? Object.entries(d.byType).map(([label, value]) => ({ label: label.replace(/_/g, ' '), value, color: '#0d9488' })) : [];

  return (
    <>
      <PageHeader title="Service Dashboard" subtitle="Service ticket pipeline, SLA and ticket mix." />
      <Grid container spacing={2} mb={1}>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#1e40af" label="Open Tickets" value={n(d?.open)} icon={<ConfirmationNumber />} hint={`${n(d?.total)} total`} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#d97706" label="Pending Spare" value={n(d?.pendingSpare)} icon={<Build />} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#dc2626" label="SLA Breached" value={n(d?.slaBreached)} icon={<ReportProblem />} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#16a34a" label="Closed" value={n(d?.closed)} icon={<CheckCircle />} hint={`${n(d?.resolved)} resolved`} /></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Tickets by Status" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent>{statusData.length ? <MiniBarChart data={statusData} valueFormatter={n} /> : <EmptyState title="No tickets yet" dense />}</CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Tickets by Type" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent>{typeData.length ? <MiniBarChart data={typeData} valueFormatter={n} /> : <EmptyState title="No tickets yet" dense />}</CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardHeader title="Recent Tickets" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent sx={{ p: 0, overflowX: 'auto' }}>
              {(d?.recent.length ?? 0) === 0 ? <EmptyState title="No tickets yet" dense /> : (
                <Table size="small">
                  <TableHead><TableRow><TableCell>Ticket</TableCell><TableCell>Type</TableCell><TableCell>Priority</TableCell><TableCell>Status</TableCell></TableRow></TableHead>
                  <TableBody>
                    {(d?.recent ?? []).map((r) => (
                      <TableRow key={r.id} hover><TableCell>{r.ticketCode}</TableCell><TableCell>{r.ticketType.replace(/_/g, ' ')}</TableCell><TableCell>{r.priority}</TableCell><TableCell><StatusBadge status={r.status} /></TableCell></TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
